import { logDOM } from "@testing-library/react";
import HttpClient from "libs/utils/HttpClient";
import qs from "qs";

class AppointmentService {
  async getAppointments(body) {
    try {
      const params = qs.stringify({
        ...(body && body.startTime && { startTime: body.startTime }),
        ...(body && body.endTime && { endTime: body.endTime }),
        ...(body &&
          body.stampAppointmentId && {
            stampAppointmentId: body.stampAppointmentId,
          }),
        ...(body && body.draftId && { draftId: body.draftId }),
      });
      const response = await HttpClient.get(`/api/stamp/list?${params}`);

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async stampAppointment(body) {
    try {
      const response = await HttpClient.post(`/api/stamp/user/add`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async AgencyCancel(body) {
    try {
      const response = await HttpClient.post(`/api/agency/cancel`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async stampAgencyCheckAppointment(body) {
    try {
      const params = qs.stringify({
        ...(body && body.draftId && { draftId: body.draftId }),
      });
      const response = await HttpClient.get(
        `/api/agency/checksubmit?${params}`
      );
      return response;
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async updateVisaDate(body) {
    try {
      const response = await HttpClient.post(
        `/api/visaformadmin/smartfrom/visavalidupdate`,
        body
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async adminApproveAppointment(body) {
    try {
      const response = await HttpClient.post(`/api/stamp/admin/add`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async userStampUploadRequest(body) {
    try {
      const response = await HttpClient.post(`/api/stamp/user/upload`, body);
      // console.log(body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  //   - api/report/benefits   ใบแจ้งสิทธิ์
  // - api/report/seal     ใบประทับตรา
  // - api/report/appoint    ใบนัด
  // - api/report/payment   ใบจ่าย

  // ใบแจ้งสิทธิ์
  async getReportBenefits(body) {
    try {
      const params = qs.stringify({
        ...(body && body.draftId && { draftId: body.draftId }),
      });
      const response = await HttpClient.getBlob(
        `/api/report/benefits?${params}`
      );
      return response;
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  // ใบแจ้งสิทธิ์ไทย
  async getReportNotifyThai(body) {
    try {
      const params = qs.stringify({
        ...(body && body.draftId && { draftId: body.draftId }),
      });
      const response = await HttpClient.getBlob(
        `/api/report/NotifyTheRightsTH?${params}`
      );
      return response;
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  // ใบแจ้งสิทธิ์อังกฤษ
  async getReportNotifyEng(body) {
    try {
      const params = qs.stringify({
        ...(body && body.draftId && { draftId: body.draftId }),
      });
      const response = await HttpClient.getBlob(
        `/api/report/NotifyTheRightsENG?${params}`
      );
      return response;
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  // ใบประทับตรา
  async getReportSeal(body) {
    try {
      const params = qs.stringify({
        ...(body && body.draftId && { draftId: body.draftId }),
      });
      const response = await HttpClient.getBlob(`/api/report/seal?${params}`);
      return response;
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  // ใบแจ้งผล
  async getReportResultSmart(body) {
    try {
      const params = qs.stringify({
        ...(body && body.draftId && { draftId: body.draftId }),
      });
      const response = await HttpClient.getBlob(
        `/api/report/resultsmartfrom?${params}`
      );
      return response;
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  // ใบนัด
  async getReportAppoint(body) {
    try {
      const params = qs.stringify({
        ...(body && body.draftId && { draftId: body.draftId }),
      });
      const response = await HttpClient.getBlob(
        `/api/report/appoint?${params}`
      );
      return response;
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  // ใบจ่าย
  async getReportPayment(body) {
    try {
      const params = qs.stringify({
        ...(body && body.draftId && { draftId: body.draftId }),
      });
      const response = await HttpClient.getBlob(
        `/api/report/payment?${params}`
      );
      return response;
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }
}

export default new AppointmentService();
